"use strict";

exports.__esModule = true;
exports.makeAddOnRuleFactory = makeAddOnRuleFactory;
var _constants = require("../constants");
var _cartProduct = require("../utils/cart-product.utils");
function makeAddOnRuleFactory(convertAndFormat) {
  if (convertAndFormat === void 0) {
    convertAndFormat = function convertAndFormat(x) {
      return x;
    };
  }
  return function ruleProductFactory(availableAddOns, addOnProducts) {
    if (availableAddOns === void 0) {
      availableAddOns = [];
    }
    if (addOnProducts === void 0) {
      addOnProducts = [];
    }
    if (Array.isArray(availableAddOns)) {
      return availableAddOns.map(function (addOn) {
        var _ADDONS_CONFIG$code;
        var code = addOn.code,
          _addOn$amount = addOn.amount,
          amount = _addOn$amount === void 0 ? 0 : _addOn$amount,
          _addOn$additionalData = addOn.additionalData,
          additionalData = _addOn$additionalData === void 0 ? {} : _addOn$additionalData;
        var _ref = additionalData,
          _ref$refundAmount = _ref.refundAmount,
          refundAmount = _ref$refundAmount === void 0 ? 0 : _ref$refundAmount,
          _ref$refundPercentage = _ref.refundPercentage,
          refundPercentage = _ref$refundPercentage === void 0 ? '0' : _ref$refundPercentage;
        return {
          code: code,
          price: convertAndFormat({
            price: amount,
            decimal: amount.toFixed(0) === amount.toString() ? 0 : 2
          }),
          refundAmount: convertAndFormat({
            price: refundAmount
          }),
          refundPercentage: refundPercentage,
          isAddOnApplied: Array.isArray(addOnProducts) && addOnProducts.some((0, _cartProduct.isAddOnApplied)(addOn.code)),
          hasTnC: !!((_ADDONS_CONFIG$code = _constants.ADDONS_CONFIG[code]) !== null && _ADDONS_CONFIG$code !== void 0 && _ADDONS_CONFIG$code.TNC_JSON)
        };
      });
    }
    return [];
  };
}